import { render, staticRenderFns } from "./recouvrements.html?vue&type=template&id=7824fa21&scoped=true&external"
import script from "./recouvrements.js?vue&type=script&lang=js&external"
export * from "./recouvrements.js?vue&type=script&lang=js&external"
import style0 from "./recouvrements.scss?vue&type=style&index=0&id=7824fa21&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824fa21",
  null
  
)

export default component.exports